import SpaceComponent from '@/modules/Space';
import React from 'react';

function SpacePage() {
  return <SpaceComponent />;
}

export default SpacePage;
